<template>
  <div id="new-date" :class="'active-'+page">
      <div class="container tab-home" :style="(isTerraceDate) ? 'height: calc(var(--vh, 1vh) * 100);' : 'height: calc(var(--vh, 1vh) * 90);'">
        <TestHomeTab :location="location" :is-terrace-date="isTerraceDate"/>
      </div>
      <div v-if="page === 'deals' && !isTerraceDate" class="container tab-deals">
        <TestMapTab :highlights="highlights" :route="route" />
      </div>
      <div v-if="!isTerraceDate" class="container tab-questions">
        <TestQuestionsTab />
      </div>
      <div v-if="!isTerraceDate" class="nav">
        <div @click="page = 'home'" class="nav-item" :class="{'active': page === 'home'}">
          <svg width="100%" height="100%" viewBox="0 0 31 28" fill="#BBBBBB" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.8336 12.7286C30.701 12.8987 30.5063 13.0093 30.2923 13.0362C30.0783 13.0631 29.8623 13.0041 29.6917 12.8722L15.4986 1.84077L1.31698 12.8804C1.14607 13.0132 0.929402 13.0727 0.714629 13.0458C0.499857 13.0188 0.304575 12.9077 0.171745 12.7368C0.0389156 12.5659 -0.0205821 12.3492 0.00634097 12.1344C0.0332641 11.9197 0.144403 11.7244 0.315308 11.5916L14.9978 0.171862C15.141 0.0604752 15.3172 0 15.4986 0C15.68 0 15.8563 0.0604752 15.9995 0.171862L30.6819 11.5916C30.8518 11.723 30.963 11.916 30.9914 12.1289C31.0198 12.3418 30.9631 12.5573 30.8336 12.7286ZM26.9183 13.0435C26.702 13.0435 26.4945 13.1294 26.3415 13.2824C26.1886 13.4354 26.1026 13.6429 26.1026 13.8592V23.6475C26.1026 24.2965 25.8448 24.9189 25.3859 25.3779C24.927 25.8368 24.3046 26.0946 23.6555 26.0946H7.34169C6.69268 26.0946 6.07026 25.8368 5.61134 25.3779C5.15242 24.9189 4.89461 24.2965 4.89461 23.6475V13.8592C4.89461 13.6429 4.80867 13.4354 4.6557 13.2824C4.50273 13.1294 4.29525 13.0435 4.07892 13.0435C3.86258 13.0435 3.65511 13.1294 3.50213 13.2824C3.34916 13.4354 3.26322 13.6429 3.26322 13.8592V23.6475C3.26322 24.7292 3.69292 25.7666 4.45778 26.5314C5.22264 27.2963 6.26001 27.726 7.34169 27.726H23.6555C24.7372 27.726 25.7746 27.2963 26.5395 26.5314C27.3043 25.7666 27.734 24.7292 27.734 23.6475V13.8592C27.734 13.6429 27.6481 13.4354 27.4951 13.2824C27.3421 13.1294 27.1347 13.0435 26.9183 13.0435Z"/>
          </svg>
        </div>
        <div @click="page = 'deals'" class="nav-item" :class="{'active': page === 'deals'}">
          <svg width="100%" height="100%" viewBox="0 0 30 30" fill="#BBBBBB" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.986 29.4174L27.1735 18.1673C27.1481 18.066 27.0895 17.976 27.0071 17.9117C26.9248 17.8474 26.8233 17.8125 26.7188 17.8125H19.6875C19.5632 17.8125 19.444 17.8619 19.356 17.9498C19.2681 18.0377 19.2188 18.1569 19.2188 18.2813C19.2188 18.4056 19.2681 18.5248 19.356 18.6127C19.444 18.7006 19.5632 18.75 19.6875 18.75H20.4933L19.7902 21.5625H16.875C16.7507 21.5625 16.6314 21.6119 16.5435 21.6998C16.4556 21.7877 16.4062 21.9069 16.4062 22.0313C16.4062 22.1556 16.4556 22.2748 16.5435 22.3627C16.6314 22.4506 16.7507 22.5 16.875 22.5H20.1563C20.2607 22.5 20.3623 22.4651 20.4446 22.4008C20.527 22.3365 20.5855 22.2465 20.6109 22.1452L21.4594 18.75H24.2438L23.4516 21.9174C23.4343 21.9865 23.4329 22.0586 23.4477 22.1283C23.4624 22.198 23.4929 22.2635 23.5367 22.3196C23.5806 22.3758 23.6366 22.4213 23.7007 22.4525C23.7647 22.4838 23.835 22.5 23.9063 22.5H27.2902L27.9933 25.3125H22.9688C22.8643 25.3125 22.7628 25.3474 22.6804 25.4117C22.598 25.476 22.5395 25.566 22.5141 25.6674L21.6656 29.0625H18.8812L19.6734 25.8952C19.6908 25.8261 19.6921 25.7539 19.6773 25.6842C19.6626 25.6145 19.6321 25.5491 19.5883 25.4929C19.5444 25.4367 19.4884 25.3913 19.4244 25.36C19.3603 25.3288 19.29 25.3125 19.2188 25.3125H2.00667L2.7098 22.5H13.125C13.2493 22.5 13.3685 22.4506 13.4564 22.3627C13.5443 22.2748 13.5937 22.1556 13.5937 22.0313C13.5937 21.9069 13.5443 21.7877 13.4564 21.6998C13.3685 21.6119 13.2493 21.5625 13.125 21.5625H2.94418L3.6473 18.75H10.3125C10.4368 18.75 10.556 18.7006 10.6439 18.6127C10.7318 18.5248 10.7812 18.4056 10.7812 18.2813C10.7812 18.1569 10.7318 18.0377 10.6439 17.9498C10.556 17.8619 10.4368 17.8125 10.3125 17.8125H3.28121C3.17671 17.8125 3.07521 17.8474 2.99283 17.9117C2.91045 17.976 2.85191 18.066 2.82652 18.1673L0.0140121 29.4174C-0.00330238 29.4865 -0.00463226 29.5586 0.0101235 29.6284C0.0248792 29.6981 0.0553323 29.7635 0.099168 29.8197C0.143004 29.8758 0.199068 29.9213 0.263101 29.9525C0.327133 29.9838 0.397448 30 0.468701 30H29.5313C29.6025 30 29.6728 29.9838 29.7369 29.9525C29.8009 29.9213 29.857 29.8758 29.9008 29.8197C29.9446 29.7635 29.9751 29.6981 29.9899 29.6284C30.0046 29.5586 30.0033 29.4865 29.986 29.4174ZM24.5067 21.5625L25.2099 18.75H26.3527L27.0558 21.5625H24.5067ZM1.7723 26.25H18.6183L17.9152 29.0625H1.06917L1.7723 26.25ZM22.6317 29.0625L23.3349 26.25H28.2277L28.9308 29.0625H22.6317Z"/>
            <path d="M15 22.5001C15.0683 22.5001 15.1358 22.4851 15.1977 22.4563C15.2597 22.4275 15.3146 22.3855 15.3586 22.3332C15.6694 21.9643 22.9688 13.2357 22.9688 7.96877C22.9688 5.85532 22.1292 3.82843 20.6348 2.334C19.1403 0.839564 17.1134 0 15 0C12.8865 0 10.8596 0.839564 9.36521 2.334C7.87078 3.82843 7.03121 5.85532 7.03121 7.96877C7.03121 13.2357 14.3306 21.9643 14.6414 22.3332C14.6854 22.3855 14.7403 22.4275 14.8022 22.4563C14.8642 22.4851 14.9317 22.5001 15 22.5001ZM15 0.937502C16.8641 0.939612 18.6513 1.68108 19.9695 2.99924C21.2877 4.3174 22.0291 6.10461 22.0313 7.96877C22.0313 12.2597 16.4798 19.4499 15 21.2902C13.5197 19.4499 7.96871 12.2616 7.96871 7.96877C7.97082 6.10461 8.71229 4.3174 10.0305 2.99924C11.3486 1.68108 13.1358 0.939612 15 0.937502Z"/>
            <path d="M20.1562 7.96877C20.1562 6.94895 19.8538 5.95204 19.2873 5.1041C18.7207 4.25616 17.9154 3.59526 16.9732 3.205C16.031 2.81473 14.9943 2.71262 13.994 2.91158C12.9938 3.11053 12.0751 3.60162 11.354 4.32274C10.6328 5.04385 10.1418 5.96261 9.9428 6.96283C9.74384 7.96305 9.84595 8.9998 10.2362 9.94198C10.6265 10.8842 11.2874 11.6895 12.1353 12.256C12.9833 12.8226 13.9802 13.125 15 13.125C16.367 13.1234 17.6776 12.5797 18.6442 11.613C19.6109 10.6464 20.1546 9.3358 20.1562 7.96877ZM10.7812 7.96877C10.7812 7.13437 11.0286 6.31872 11.4922 5.62495C11.9558 4.93118 12.6147 4.39045 13.3855 4.07114C14.1564 3.75183 15.0047 3.66829 15.823 3.83107C16.6414 3.99385 17.3931 4.39565 17.9831 4.98565C18.5731 5.57566 18.9749 6.32737 19.1377 7.14573C19.3005 7.96409 19.2169 8.81234 18.8976 9.58322C18.5783 10.3541 18.0376 11.013 17.3438 11.4765C16.65 11.9401 15.8344 12.1875 15 12.1875C13.8815 12.1863 12.8091 11.7414 12.0182 10.9505C11.2273 10.1596 10.7825 9.08727 10.7812 7.96877Z"/>
          </svg>
        </div>
        <div @click="page = 'questions'" class="nav-item" :class="{'active': page === 'questions'}">
          <svg width="100%" height="100%" viewBox="0 0 30 29" fill="#BBBBBB" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.94426 0.578003H21.1164C22.7373 0.578003 24.0607 1.9014 24.0607 3.52226V14.2299C24.0607 15.8511 22.7373 17.1745 21.1164 17.1745H9.0398L4.6711 22.5359C4.25034 23.0535 3.39999 22.7518 3.39964 22.0848V17.1745H2.94426C1.3234 17.1745 0 15.8511 0 14.2299V3.52226C0 1.9014 1.3234 0.578003 2.94426 0.578003ZM18.5802 6.61808C19.8273 6.61808 20.8384 7.62917 20.8384 8.87626C20.8384 10.1233 19.8273 11.1344 18.5802 11.1344C17.3331 11.1344 16.322 10.1233 16.322 8.87626C16.322 7.63306 17.337 6.61808 18.5802 6.61808ZM18.5802 8.05205C18.1209 8.05205 17.756 8.41699 17.756 8.87626C17.756 9.33129 18.1248 9.70047 18.5802 9.70047C19.0356 9.70047 19.4044 9.33129 19.4044 8.87626C19.4044 8.42088 19.0356 8.05205 18.5802 8.05205ZM12.0303 6.61808C13.2732 6.61808 14.2885 7.63306 14.2885 8.87626C14.2885 10.1233 13.2774 11.1344 12.0303 11.1344C10.7868 11.1344 9.77215 10.1198 9.77215 8.87626C9.77215 7.62917 10.7832 6.61808 12.0303 6.61808ZM12.0303 8.05205C11.575 8.05205 11.2061 8.42088 11.2061 8.87626C11.2061 9.33482 11.5718 9.70047 12.0303 9.70047C12.4854 9.70047 12.8545 9.33129 12.8545 8.87626C12.8545 8.41699 12.4896 8.05205 12.0303 8.05205ZM5.48047 6.61808C6.72368 6.61808 7.73866 7.63306 7.73866 8.87626C7.73866 10.1233 6.72756 11.1344 5.48047 11.1344C4.23339 11.1344 3.22229 10.1233 3.22229 8.87626C3.22229 7.63306 4.23727 6.61808 5.48047 6.61808ZM5.48047 8.05205C5.02121 8.05205 4.65627 8.41699 4.65627 8.87626C4.65627 9.33129 5.02509 9.70047 5.48047 9.70047C5.93586 9.70047 6.30468 9.33129 6.30468 8.87626C6.30468 8.41699 5.93974 8.05205 5.48047 8.05205ZM6.81518 22.3476C5.97542 21.924 6.6191 20.6469 7.45921 21.0709C7.67365 21.179 7.89763 21.2309 8.13681 21.2309H20.5512C20.7956 21.2309 21.0115 21.3535 21.1408 21.5404L24.4196 25.5639V21.9477C24.4196 21.552 24.7407 21.2309 25.1364 21.2309H26.309C27.1381 21.2309 27.8192 20.5498 27.8192 19.7203V9.01263C27.8192 8.18312 27.1381 7.50234 26.309 7.50234H25.448C24.5047 7.50234 24.5047 6.06837 25.448 6.06837H26.309C27.9298 6.06837 29.2532 7.39141 29.2532 9.01263V19.7203C29.2532 21.3415 27.9298 22.6649 26.309 22.6649H25.8536V27.5752C25.8532 28.2422 25.0029 28.5439 24.5821 28.0263L20.2134 22.6649H8.13681C7.67931 22.6649 7.22322 22.5543 6.81518 22.3476ZM21.1164 2.01198H2.94426C2.1151 2.01198 1.43397 2.69311 1.43397 3.52226V14.2299C1.43397 15.0594 2.1151 15.7405 2.94426 15.7405H4.1168C4.51248 15.7405 4.83361 16.0617 4.83361 16.4577V20.0736L8.11243 16.05C8.24173 15.8631 8.45759 15.7405 8.70206 15.7405H21.1164C21.9456 15.7405 22.6267 15.0594 22.6267 14.2299V3.52226C22.6267 2.69311 21.9456 2.01198 21.1164 2.01198Z"/>
          </svg>
        </div>
      </div>
    </div>
</template>

<style lang="scss">
@font-face {
  font-family: DM Sans;
  src: url(/src/assets/fonts/DMSans-Regular.ttf);
  font-weight: normal;
  font-style: normal;
}

#new-date {
  font-family: DM Sans, sans-serif;
  height: calc(var(--vh, 1vh) * 100);
  width: 100%;
  display: flex;
  flex-direction: column;

  .active-home .tab-home {
    display: block;
  }

  .active-deals .tab-deals {
    display: block;
  }

  .active-questions .tab-questions {
    display: block;
  }

  .divider {
    border-bottom: 1px solid #BBBBBB;
    width: calc(100% - 20px);
    margin: 0 10px;
  }

  .nav {
    height: calc(var(--vh, 1vh) * 10);
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background-color: white;
    border: none;
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);
    z-index: 1;

    &-item {
      display: flex;
      align-items: center;
    }

    div {
      padding: 16px;
      color: #BBBBBB;
      display: flex;
      text-align: center;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
      width: 100%;

      &:active, &.active {
        border-top: 3px solid #2140A1;
        svg {
          fill: #2140A1;
        }
      }
    }
  }
}

.container {
  display: none;
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
}

</style>

<script>

import TestQuestionsTab from "@/components/Tabs/Test/TestQuestionsTab";
import {routes} from "@/store/routes";
import TestHomeTab from "@/components/Tabs/Test/TestHomeTab";
import TestMapTab from "@/components/Tabs/Test/TestMapTab";
import {requests} from "@/_helpers/requests";

export default {
  name: 'TestDate',
  components: {
    TestMapTab,
    TestHomeTab,
    TestQuestionsTab,
  },
  data() {
    return {
      page: 'home',
      route: null,
      routeName: 'default',
      isTerraceDate: true,
      location: {},
      highlights: []
    }
  },
  async created() {
    let location = await requests.get('locations/'+ this.$route.params.locationId);
    this.location = location.data;

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    if (this.$route.params.startLat && this.$route.params.startLon) {
      this.isTerraceDate = false;
      this.setRoute();
      this.getHighlights();
    }
  },
  methods: {
    setRoute() {
        this.route = routes[this.location.cityId][this.routeName];
        this.route.startLat = parseFloat(this.$route.params.startLat.replace('-', '.'));
        this.route.startLon = parseFloat(this.$route.params.startLon.replace('-', '.'));
    },
    getHighlights() {
      //get highlights
    }
  }
}
</script>
